var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90625 7C1.90625 4.48093 1.90625 3.2214 2.68882 2.43882C3.4714 1.65625 4.73093 1.65625 7.25 1.65625C9.76904 1.65625 11.0286 1.65625 11.8112 2.43882C12.5938 3.2214 12.5938 4.48093 12.5938 7C12.5938 9.51904 12.5938 10.7786 11.8112 11.5612C11.0286 12.3438 9.76904 12.3438 7.25 12.3438C4.73093 12.3438 3.4714 12.3438 2.68882 11.5612C1.90625 10.7786 1.90625 9.51904 1.90625 7Z",
    stroke: "#007AFF",
    strokeWidth: 0.84375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78125 7C9.78125 8.39798 8.64798 9.53125 7.25 9.53125C5.85203 9.53125 4.71875 8.39798 4.71875 7C4.71875 5.60203 5.85203 4.46875 7.25 4.46875C8.64798 4.46875 9.78125 5.60203 9.78125 7Z",
    stroke: "#007AFF",
    strokeWidth: 0.84375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3481 3.90625H10.3431",
    stroke: "#007AFF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0a8a0fdfab63ae01832052f966bb6322.svg";
export { ForwardRef as ReactComponent };